import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card, CardBody, Button, FormGroup, Label, Input, Form, Modal, ModalHeader, ModalBody, ModalFooter, UncontrolledTooltip } from "reactstrap";
import Select from "react-select";
import { useFormik } from "formik";
import * as Yup from "yup";
import Breadcrumbs from "../../../../components/Common/Breadcrumb";
import TableContainer from "../../../../components/Common/TableContainer";
import { Countries } from "common/data/constants";
import CustomSelect from "components/Common/custom-select";
import { useDispatch, useSelector } from "react-redux";
import { useAuthUserDetails } from "components/Common/getAuthUserDetails";
import { fetchDesignations, fetchEmployeeDropdown, fetchEmployeeDropdownAutoList, fetchImportTemplate, fetchOnboardingImportList, fetchOnboardingJobCode, saveOnboardingApplyJob, uploadOnboardingImportFile } from "store/actions";
import Loader from "common/pageLoader";
import CustomDatePicker from "common/CustomDatePicker";
import dayjs from "dayjs";
import { DatePicker } from "antd";
import { Link } from "react-router-dom/cjs/react-router-dom";

const referralOptions = [
  { value: 1, label: "Referral" },
  { value: 2, label: "Internet Search" },
  { value: 3, label: "Job Fair" },
  { value: 4, label: "Others" },
];

const experienceOptions = [
  { value: 1, label: "Fresher" },
  { value: 2, label: "Experienced" },
  { value: 3, label: "Contractor" },
  { value: 4, label: "Consultant" },
];

const ApplyJob = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [file, setFile] = useState(null);
  const [fileError, setFileError] = useState("");
  const dispatch = useDispatch();
  const [authDetails, setAuthDetails] = useState(null);
  const {
    jobCodes,
    importList,
    loading,
    dropdownData,
    dropdownAutoList,
    designations,
    importTemplateUrl,
    success,
    error,
  } = useSelector((state) => ({
    jobCodes: state.RecruitmentOnboardingReducer?.jobCodes ?? [],
    importList: state.RecruitmentOnboardingReducer?.importList ?? [],
    dropdownData: state.EmployeeDetailsReducer?.dropdownData,
    dropdownAutoList: state.EmployeeDetailsReducer?.dropdownAutoList ?? [],
    designations: state.DesignationMaster?.designations ?? [],
    importTemplateUrl: state.RecruitmentOnboardingReducer?.importTemplateUrl ?? [],

    loading: state.RecruitmentOnboardingReducer?.loading || state.EmployeeDetailsReducer?.loading || state.DesignationMaster?.loading,
    error: state.RecruitmentOnboardingReducer?.error || state.EmployeeDetailsReducer?.error || state.DesignationMaster?.error,
    success: state.RecruitmentOnboardingReducer?.success,
  }));
  const { country, state } = dropdownData;
  const [isEdit, setIsEdit] = useState(false);
  const [editId, setEditId] = useState(null);
  const countryOptions = (country || []).map((cat) => ({
    value: cat.country_id.toString(),
    label: cat.country_name,
  }));

  const stateOptions = (state || []).map((s) => ({
    value: s.state_id.toString(),
    label: s.state_name,
  }));

  useEffect(() => {
    const authUserDetails = useAuthUserDetails();
    setAuthDetails(authUserDetails[0])
    const unitId = authUserDetails[0].unit_id
    dispatch(fetchOnboardingJobCode(unitId));
    dispatch(fetchOnboardingImportList(unitId))
    dispatch(fetchEmployeeDropdown(unitId))
    dispatch(fetchEmployeeDropdownAutoList(unitId));
    dispatch(fetchDesignations(unitId));
  }, [dispatch]);

  useEffect(() => {
    if (success) {
     dispatch(fetchOnboardingImportList(authDetails?.unit_id))
     handleCancel()
    }
  }, [authDetails, success, dispatch]);

  useEffect(() => {
    if (importTemplateUrl) {
      const fileUrl = `${process.env.REACT_APP_IMAGE_BASE_URL}${importTemplateUrl}`;

      const link = document.createElement('a');
      link.href = fileUrl;
      link.setAttribute('download', 'candidate_template.xlsx'); // Optional filename
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }, [importTemplateUrl]);

  const handleOpenModal = () => {
    setIsModalOpen(true);
    setFile(null);
    setFileError("");
  };

  const handleStartImport = () => {
    if (!file) {
      setFileError("Please select a file to import.");
      return;
    }
    const formData = new FormData();
    formData.append("rec_file", file);
    formData.append("create_by", authDetails?.user_id); 
    formData.append("unit_id", authDetails?.unit_id);
    dispatch(uploadOnboardingImportFile(formData))
    dispatch(fetchOnboardingImportList(authDetails?.unit_id))
    setIsModalOpen(false);
  };

  const getTemplate=()=>{
    const formData = new FormData();
    formData.append("create_by", authDetails?.user_id); 
    formData.append("unit_id", authDetails?.unit_id);
    dispatch(fetchImportTemplate(formData))
  }

  const handleEdit = (row) => {
    setIsEdit(true);
    setEditId(row.applicant_id);

    formik.setValues({
      name: row.name || "",
      email: row.email || "",
      address1: row.address_1 || "",
      address2: row.address_2 || "",
      country: row.country_id ? { value: row.country_id.toString(), label: row.country } : null,
      state: row.state_id ? { value: row.state_id.toString(), label: row.state } : null,
      city: row.city || "",
      zipcode: row.pincode?.toString() || "",
      mobile: row.mobile_no || "",
      aadhar: row.aadhar_no || "",
      pan: row.pan_no || "",
      license: row.license_no || "",
      qualification: row.qualification || "",
      workedBefore: row.already_worked_id?.toString() || "",
      workedFromYear: row.worked_period_from?.toString() || null,
      workedToYear: row.worked_period_to?.toString() || null,
      referral: row.through_know_id ? referralOptions.find(opt => opt.value === row.through_know_id) : null,
      employee: row.refby ? { value: row.refby.toString(), label: row.reference } : null,
      jobCode: row.pos_id && row.job_code ? { value: row.pos_id.toString(), label: row.job_code } : null,
      joinDate: row.exp_join_dt || "",
      experience: row.pre_exp_level ? experienceOptions.find(opt => opt.value === row.pre_exp_level) : null,
      experienceYears: row.exp_years?.toString() || "",
      designation: row.exp_designation ? { value: row.exp_designation, label: row.exp_designation } : null,
      resume: null,
      exp: row.exp_salary?.toString() || "",
    });
  };

  const columns = [
    { Header: "S.No", Cell: ({ row }) => importList.length - row.index, className: "serial-no", applyHeaderClass: true, },
    { Header: "Name", accessor: "name" },
    { Header: "E-Mail", accessor: "email" },
    { Header: "Mobile", accessor: "mobile_no" },
    { Header: "Position", accessor: "position_apply" },
    // { Header: "Job Code", accessor: "jobCode" },
    { Header: "Pre Exp Year", accessor: "pre_exp" },
    { Header: "Exp Salary", accessor: "exp_salary" }, 
    {
      Header: "Action",
      // className: "action-col",
      // applyHeaderClass: true,
      Cell: (cellProps) => {
        const { applicant_id } = cellProps.row.original;
        return (
          <div className="d-flex gap-3">
            <Link to="#" className="text-success" onClick={() => handleEdit(cellProps.row.original)}>
              <i className="bx bxs-edit font-size-18" id={`edittooltip-${applicant_id}`} />
              <UncontrolledTooltip placement="top" target={`edittooltip-${applicant_id}`}>
                Edit
              </UncontrolledTooltip>
            </Link>
          </div>
        );
      },
    },
  ];

  const formik = useFormik({
    initialValues: {
      name: "",
      email: "",
      address1: "",
      address2: "",
      country: null,
      state: "",
      city: "",
      zipcode: "",
      mobile: "",
      aadhar: "",
      pan: "",
      license: "",
      qualification: "",
      workedBefore: "",
      workedFromYear:null,
      workedToYear:null,
      referral: null,
      jobCode: null,
      joinDate: "",
      experience: null,
      experienceYears:"",
      designation:"",
      resume: null,
      exp:"",
      employee:"",
    },
    validationSchema: Yup.object({
      name: Yup.string()
      .required("Name is required"),    
      email: Yup.string()
        .email("Invalid email")
        .required("Email is required"),        
      address1: Yup.string()
        .required("Address is required"),        
      country: Yup.object()
        .nullable() 
        .required("Country is required"),        
      state: Yup.object()
        .nullable() 
        .required("State is required"),        
      city: Yup.string()
        .required("City is required"),        
      zipcode: Yup.string()
        .matches(/^\d{5,6}$/, "Zipcode must be 5 or 6 digits")
        .required("Zipcode is required"),        
      mobile: Yup.string()
        .matches(/^[6-9]\d{9}$/, "Mobile number must be a valid 10-digit Indian number")
        .required("Mobile number is required"),        
      aadhar: Yup.string()
        .matches(/^\d{12}$/, "Aadhar number must be 12 digits")
        .required("Aadhar No is required"),        
      pan: Yup.string()
        .matches(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/, "Invalid PAN format (e.g., ABCDE1234F)")
        .required("PAN No is required"),        
      license: Yup.string()
        .matches(/^[A-Z0-9]{5,20}$/, "Invalid License format")
        .required("License No is required"),
      qualification: Yup.string().required("Qualification is required"),
      exp: Yup.string().required("Expected Salary is required"),
      referral: Yup.object().nullable().required("Referral source is required"),
      jobCode: Yup.object().nullable().required("Job Code is required"),
      joinDate: Yup.date().nullable().required("Joining date is required"),
      experience: Yup.object().nullable().required("Previous Exp. Level is required"),
      experienceYears: Yup.string().when("experience", {
        is: (experience) => !experience || experience.value !== 1,
        then: Yup.string()
          .required("Experience years is required")
          // .matches(/^\d+$/, "Enter a valid number of years")
          .test("range", "Years should be between 0 and 50", value => {
            const num = parseInt(value);
            return !isNaN(num) && num >= 0 && num <= 50;
          }),
        otherwise: Yup.string().nullable(),
      }),

      designation: Yup.mixed().when("experience", {
        is: (experience) => !experience || experience.value !== 1,
        then: Yup.mixed().required("Previous designation is required"),
        otherwise: Yup.mixed().nullable(),
      }),
      resume: Yup.mixed().required("Resume is required"),
      // file: Yup.mixed().required("file is required"),
      workedBefore: Yup.string().required("Are you worked before with us"),
      workedFromYear: Yup.string().when("workedBefore", {
        is: "2", // Only validate if "2"
        then: Yup.string()
          .nullable()
          .required("From year is required")
          .matches(/^\d{4}$/, "Enter a valid year")
          .test("from-before-to", "From year must be before To year", function (value) {
            const { workedToYear } = this.parent;
            if (!value || !workedToYear) return true;
            return parseInt(value) <= parseInt(workedToYear);
          }),
        otherwise: Yup.string().nullable(), // Not required otherwise
      }),

      workedToYear: Yup.string().when("workedBefore", {
        is: "2",
        then: Yup.string()
          .nullable()
          .required("To year is required")
          .matches(/^\d{4}$/, "Enter a valid year")
          .test("to-after-from", "To year must be after From year", function (value) {
            const { workedFromYear } = this.parent;
            if (!value || !workedFromYear) return true;
            return parseInt(value) >= parseInt(workedFromYear);
          }),
        otherwise: Yup.string().nullable(), // Not required otherwise
      }),
    }),
    onSubmit: (values) => {
      const formData = new FormData();

      // Applicant Basic Info
      formData.append("applicant_id", editId ? editId : 0);
      formData.append("name", values.name || "");
      formData.append("email", values.email || "");
      formData.append("address1", values.address1 || "");
      formData.append("address2", values.address2 || "");
      formData.append("country", values.country?.value || "");
      formData.append("state", values.state?.value || "");
      formData.append("city", values.city || "");
      formData.append("zip_code", values.zipcode || "");
      formData.append("mobile_no", values.mobile || "");
      formData.append("aadhar_no", values.aadhar || "");
      formData.append("pan_no", values.pan || "");
      formData.append("license_no", values.license || "");
      formData.append("qualification", values.qualification || "");

      // Work History
      formData.append("already_worked", values.workedBefore || ""); // "1" or "2" etc.
      formData.append("worked_Period_from", values.workedFromYear || "");
      formData.append("worked_Period_to", values.workedToYear || "");

      // Salary & Referral
      formData.append("expected_salary", values.exp || "");
      formData.append("through_know", values.referral?.value || 0);
      formData.append("ref_by", values.referral?.value || 0);

      // Job Position
      formData.append("pos_id", values.jobCode?.value?.toString() || 0);
      formData.append("exp_join_date", values.joinDate || "");

      // Experience
      formData.append("pre_exp_level", values.experience?.value || 0);
      formData.append("exp_designation", values.designation?.value || 0);
      formData.append("exp_years", values.experienceYears || "");
      // formData.append("exp_month", ""); 

      // Meta Info
      formData.append("create_by", authDetails?.user_id?.toString() || "");
      formData.append("unit_id", authDetails?.unit_id?.toString() || "");

      // Resume Attachment
      if (values.resume && values.resume.name) {
        formData.append("file_attach", values.resume);
      }
      dispatch(saveOnboardingApplyJob(formData))
    },
  });
  const handleCancel = () => {
      setIsEdit(false);
      setEditId(null);
      formik.resetForm()
  };

  return (
    <div className="page-content">
      <Loader loading={loading}/>
      <Container fluid>
        <Breadcrumbs title="Onboarding" breadcrumbItem="Apply Job" />
        <div className="d-flex justify-content-end align-items-center mb-3 flex-wrap gap-2">
          <Button type="button" className="btn button-export" onClick={getTemplate}>
            <i className="fas fa-file-export me-1" /> Get Template
          </Button>
          <Button type="button" className="btn button-send" onClick={handleOpenModal}>
            <i className="fas fa-file-import me-1" /> Import
          </Button>
          <Button type="submit" form="applyJobForm" className="btn button-save">
            <i className="fas fa-save me-1" /> {isEdit ? "Update" : "Apply"}
          </Button>
          <Button className="btn button-cancel" onClick={handleCancel}>
            <i className="fas fa-sync me-1" /> Cancel
          </Button>
        </div>
        <Card>
          <CardBody>
            <Form id="applyJobForm" onSubmit={formik.handleSubmit}>
              <Row>
                <Col md={6}>
                  <h5 className="text-primary pb-2">Personal Details</h5>
                  {/* <Row>
                    {[
                    { label: "Name", name: "name" },
                    { label: "Email Address", name: "email" },
                    { label: "Address1", name: "address1" },
                    { label: "Address2", name: "address2" },
                    { label: "State", name: "state" },
                    { label: "City", name: "city" },
                    { label: "Zipcode", name: "zipcode" },
                    { label: "Mobile No", name: "mobile" },
                    { label: "Aadhar No", name: "aadhar" },
                    { label: "PAN No", name: "pan" },
                    { label: "License No", name: "license" },
                  ].map((field, index) => (
                    <Col md={6} key={index}>
                      <FormGroup >
                        <Label>{field.label} <span className="text-danger">*</span></Label>
                        <Input
                          type="text"
                          name={field.name}
                          value={formik.values[field.name]}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                        />
                        {formik.touched[field.name] && formik.errors[field.name] && (
                          <div className="text-danger ">{formik.errors[field.name]}</div>
                        )}
                      </FormGroup>
                    </Col>
                  ))}
                  <Col md={6}>
                    <FormGroup>
                      <Label>Country <span className="text-danger">*</span></Label>
                      <CustomSelect
                        options={(country || []).map(cat => ({ value: cat.country_id.toString(), label: cat.country_name }))}
                        value={formik.values.country}
                        onChange={(opt) => formik.setFieldValue("country", opt)}
                      />
                      {formik.touched.country && formik.errors.country && (
                        <div className="text-danger ">{formik.errors.country}</div>
                      )}
                    </FormGroup>
                  </Col>
                  </Row> */}

                  <Row>
                    {[
                      { label: "Name", name: "name" },
                      { label: "Email Address", name: "email" },
                      { label: "Address1", name: "address1" },
                      { label: "Address2", name: "address2" },
                      { label: "Country", name: "country", type: "select" },
                      { label: "State", name: "state", type: "select" },
                      { label: "City", name: "city" },
                      { label: "Zipcode", name: "zipcode" },
                      { label: "Mobile No", name: "mobile" },
                      { label: "Aadhar No", name: "aadhar" },
                      { label: "PAN No", name: "pan" },
                      { label: "License No", name: "license" },
                    ].map((field, index) => (
                      <Col md={6} key={index}>
                        <FormGroup>
                          <Label>
                            {field.label} <span className="text-danger">*</span>
                          </Label>

                          {field.type === "select" ? (
                            <CustomSelect
                              name={field.name}
                              options={
                                field.name === "country" ? countryOptions :
                                field.name === "state" ? stateOptions :
                                []
                              }
                              value={formik.values[field.name]}
                              onChange={(value) => formik.setFieldValue(field.name, value)}
                              onBlur={() => formik.setFieldTouched(field.name, true)}
                            />
                          ) : (
                            <Input
                              type="text"
                              name={field.name}
                              value={formik.values[field.name]}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                            />
                          )}

                          {formik.touched[field.name] && formik.errors[field.name] && (
                            <div className="text-danger">{formik.errors[field.name]}</div>
                          )}
                        </FormGroup>
                      </Col>
                    ))}
                  </Row>
                  
                </Col>
                <Col md={6}>
                  <h5 className="text-primary pb-2">Academic Details</h5>
                  <Row>
                    <Col md={6}>
                    <FormGroup>
                      <Label>Qualification <span className="text-danger">*</span></Label>
                      <Input
                        type="text"
                        name="qualification"
                        value={formik.values.qualification}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      />
                      {formik.touched.qualification && formik.errors.qualification && (
                        <div className="text-danger ">{formik.errors.qualification}</div>
                      )}
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup>
                    <Label>Expected Salary <span className="text-danger">*</span></Label>
                    <Input
                      type="text"
                      name="exp"
                      value={formik.values.exp}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched.exp && formik.errors.exp && (
                      <div className="text-danger ">{formik.errors.exp}</div>
                    )}
                  </FormGroup>
                  </Col>                 
                  <Col md={6}>
                    <FormGroup>
                      <Label>Have you worked with us already? <span className="text-danger">*</span></Label>
                      <div className="d-flex align-items-center gap-2 check-input min-height-42">
                        <Input type="radio" name="workedBefore" value="1" checked={formik.values.workedBefore === "1"} onChange={formik.handleChange} /> No
                        <Input type="radio" name="workedBefore" value="2" className="ms-3" checked={formik.values.workedBefore === "2"} onChange={formik.handleChange} /> Yes
                      </div>
                      {formik.touched.workedBefore && formik.errors.workedBefore && (
                        <div className="text-danger ">{formik.errors.workedBefore}</div>
                      )}
                    </FormGroup>
                  </Col>
                  {formik.values.workedBefore === "2" && (
                    <>
                      <Col md={3}>
                        <FormGroup>
                          <Label>Worked From <span className="text-danger">*</span></Label>
                          <DatePicker
                            picker="year"
                            format="YYYY"
                            name="workedFromYear"
                            value={formik.values.workedFromYear ? dayjs(formik.values.workedFromYear, "YYYY") : null}
                            onChange={(date, dateString) => formik.setFieldValue("workedFromYear", dateString)}
                            onBlur={() => formik.setFieldTouched("workedFromYear", true)}
                          />
                          {formik.touched.workedFromYear && formik.errors.workedFromYear && (
                            <div className="text-danger">{formik.errors.workedFromYear}</div>
                          )}
                        </FormGroup>
                      </Col>

                      <Col md={3}>
                        <FormGroup>
                          <Label>Worked To <span className="text-danger">*</span></Label>
                          <DatePicker
                            picker="year"
                            format="YYYY"
                            name="workedToYear"
                            value={formik.values.workedToYear ? dayjs(formik.values.workedToYear, "YYYY") : null}
                            onChange={(date, dateString) => formik.setFieldValue("workedToYear", dateString)}
                            onBlur={() => formik.setFieldTouched("workedToYear", true)}
                          />
                          {formik.touched.workedToYear && formik.errors.workedToYear && (
                            <div className="text-danger">{formik.errors.workedToYear}</div>
                          )}
                        </FormGroup>
                      </Col>
                    </>
                  )}
                   <Col md={6}>
                    <FormGroup>
                      <Label>Where did you hear about us through? <span className="text-danger">*</span></Label>
                      <CustomSelect
                        options={referralOptions}
                        value={formik.values.referral}
                        onChange={(opt) => formik.setFieldValue("referral", opt)}
                      />
                      {formik.touched.referral && formik.errors.referral && (
                        <div className="text-danger ">{formik.errors.referral}</div>
                      )}
                    </FormGroup>
                  </Col>
                  {formik.values.referral?.value === 1 && (
                    <Col md={6}>
                      <FormGroup>
                        <Label for="employee">Referred by</Label>
                        <CustomSelect
                          id="employee"
                          name="employee"
                          options={(dropdownAutoList || []).map(bg => ({ value: bg.emp_id.toString(), label: bg.emp_no }))}
                          value={formik.values.employee || null}
                          onChange={(selectedOption) => formik.setFieldValue("employee", selectedOption)}
                          onBlur={formik.handleBlur}
                          className={formik.touched.employee && formik.errors.employee ? "is-invalid" : ""}
                        />
                        {formik.touched.employee && formik.errors.employee && (
                          <div className="text-danger">{formik.errors.employee}</div>
                        )}
                      </FormGroup>
                    </Col>
                  )}                  
                  <Col md={6}>
                    <FormGroup>
                    <Label>Job Code <span className="text-danger">*</span></Label>
                    <CustomSelect
                      options={jobCodes.map(item => ({ value: item.position_id, label: item.position }))}
                      value={formik.values.jobCode}
                      onChange={selectedOption => formik.setFieldValue("jobCode", selectedOption)}
                      onBlur={() => formik.setFieldTouched("jobCode", true)} 
                    />
                    {formik.touched.jobCode && formik.errors.jobCode && (
                      <div className="text-danger ">{formik.errors.jobCode}</div>
                    )}
                  </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup>
                      <Label>Expected Date of joining if selected? <span className="text-danger">*</span></Label>
                      <CustomDatePicker
                        name="joinDate"
                        value={formik.values.joinDate}
                        onChange={(date) => formik.setFieldValue("joinDate", date)}
                        onBlur={formik.handleBlur}
                        className={`form-control ${formik.touched.joinDate && formik.errors.joinDate ? "is-invalid" : ""}`}
                      />
                      {formik.touched.joinDate && formik.errors.joinDate && (
                        <div className="text-danger ">{formik.errors.joinDate}</div>
                      )}
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup>
                      <Label>Previous Exp. Level <span className="text-danger">*</span></Label>
                      <CustomSelect
                        options={experienceOptions}
                        value={formik.values.experience}
                        onChange={(opt) => formik.setFieldValue("experience", opt)}
                      />
                      {formik.touched.experience && formik.errors.experience && (
                        <div className="text-danger ">{formik.errors.experience}</div>
                      )}
                    </FormGroup>
                  </Col>
                  {(!formik.errors.experience && (!formik.values.experience || formik.values.experience?.value !== 1)) && (
                   <>
                    <Col md={6}>
                      <FormGroup>
                        <Label>Years of Experience <span className="text-danger">*</span></Label>
                        <Input
                          type="text"
                          name="experienceYears"
                          placeholder="Enter years"
                          min={0}
                          max={50}
                          value={formik.values.experienceYears}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                        />
                        {formik.touched.experienceYears && formik.errors.experienceYears && (
                          <div className="text-danger">{formik.errors.experienceYears}</div>
                        )}
                      </FormGroup>
                    </Col>
                    <Col md={6}>
                      <FormGroup>
                        <Label>Previous Designation <span className="text-danger">*</span></Label>
                        <CustomSelect
                          options={designations.map(desig => ({ value: desig.desig_id, label: desig.designation }))}
                          value={formik.values.designation}
                          onChange={(opt) => formik.setFieldValue("designation", opt)}
                        />
                        {formik.touched.designation && formik.errors.designation && (
                          <div className="text-danger ">{formik.errors.designation}</div>
                        )}
                      </FormGroup>
                    </Col>
                   </>
                  )}                  
                  <Col md={6}>
                      <FormGroup>
                    <Label>Upload Resume <span className="text-danger">*</span></Label>
                    <Input type="file" name="resume" onChange={(event) => formik.setFieldValue("resume", event.currentTarget.files[0])} />
                    {formik.touched.resume && formik.errors.resume && (
                      <div className="text-danger ">{formik.errors.resume}</div>
                    )}
                  </FormGroup>
                  </Col>
                  {/* <Col md={6}>
                    <FormGroup>
                      <Label>File(.xlsx) <span className="text-danger">*</span></Label>
                      <Input type="file" name="file" onChange={(event) => formik.setFieldValue("file", event.currentTarget.files[0])} />
                      {formik.touched.file && formik.errors.file && (
                        <div className="text-danger ">{formik.errors.file}</div>
                      )}
                    </FormGroup>
                  </Col> */}
                  {/* </Row>
                  <Row className="mt-3"> */}
                  </Row>
                </Col>
              </Row>

            </Form>
          </CardBody>
        </Card>
        <Card>
          <CardBody>
            <TableContainer
              columns={columns}
              data={importList}
              isGlobalFilter={true}
              customPageSize={10}
              className="custom-table"
            />
          </CardBody>
        </Card>
        <Modal isOpen={isModalOpen} toggle={() => setIsModalOpen(false)} centered>
          <ModalHeader toggle={() => setIsModalOpen(false)}>
            Upload File for Import
          </ModalHeader>
          <ModalBody>
            <FormGroup>
              <Label>Upload Excel File (.xlsx) <span className="text-danger">*</span></Label>
              <Input
                type="file"
                accept=".xlsx"
                onChange={(e) => {
                  setFile(e.target.files[0]);
                  setFileError("");
                }}
              />
              {fileError && <div className="text-danger mt-1">{fileError}</div>}
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={handleStartImport}>
              Submit
            </Button>
            <Button color="secondary" onClick={() => setIsModalOpen(false)}>
              Cancel
            </Button>
          </ModalFooter>
        </Modal>
      </Container>
    </div>
  );
};

export default ApplyJob;
